import { z } from 'zod';

export const SchemaEnvironment = z
  .object({
    NODE_ENV: z.enum(['development', 'production']),
    REACT_APP_NAMESPACE: z.enum(['biz-tecma-prod', 'biz-tecma-pre-prod', 'biz-tecma-dev1', 'biz-tecma-test', 'biz-tecma-demo-prod']),
    REACT_APP_BASE_URL: z.string(),
    REACT_APP_HOST: z.string(),
    REACT_APP_NAME: z.string(),
    REACT_APP_WEB_PROTOCOL: z.string(),
    REACT_APP_VERSION: z.string(),
    REACT_APP_APOLLO_URI: z.string(),
    REACT_APP_API_URI: z.string(),
    REACT_APP_PROJECT_API_BASE_URL: z.string(),
    REACT_APP_BUCKET_BASEURL: z.string(),
    REACT_APP_AWS_TOKEN: z.string(),
    REACT_APP_AWS_API_URI: z.string(),
    REACT_APP_CLIENT_API_REST_URI: z.string(),
    REACT_APP_TOKEN_EXPIRATION_THRESHOLD: z.string(),
    REACT_APP_PUBLIC_URL: z.string(),
    REACT_APP_ASSET_API_REST_URI: z.string(),
    REACT_APP_PRODUCT_CONFIGURATION_API_REST_URI: z.string(),
    REACT_APP_DISABLE_SEND_REQUEST_FLOW: z.boolean(),
  })
  .strict();
